import {createContext} from 'react';

export type MessageContextType = {
    setSuccessMessage: (message: string) => void,
    setErrorMessage: (message: string) => void,
    setInfoMessage: (message: string) => void,
};

export const MessageContext = createContext<MessageContextType>({
    setSuccessMessage: () => undefined,
    setErrorMessage: () => undefined,
    setInfoMessage: () => undefined,
});
